import { createContext } from 'react'

export interface BffAuthContextValue {
    signOut: () => Promise<void>
}

export const BffAuthContext = createContext<BffAuthContextValue | null>(null)
